<script setup lang="ts"></script>

<template>
  <div class="spinner" />
</template>

<style scoped lang="scss">
.spinner {
  --size-spinner: 16px;
  width: var(--size-spinner);
  height: var(--size-spinner);
  border: 2px solid var(--color-secondary-70);
  border-top-color: transparent;
  border-radius: 50%;
  animation: rotate 2s linear infinite;

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
